import type { ReactNode } from "react";

import type { SystemCatalogAdminBootstrapData } from "@/app/admin/adminTypes";
import type { SystemCatalogSelection } from "./systemCatalogAdminModel";

export interface SystemCatalogAdminProps {
  initialData: SystemCatalogAdminBootstrapData;
  initialSelection: SystemCatalogSelection;
}

export interface CatalogCardAction {
  label: string;
  onClick: () => void;
  tone?: "default" | "danger";
}

export const SYSTEM_CATALOG_DRAG_MIME = "application/x-system-catalog-admin";

export type SystemCatalogDragPayload =
  | {
      kind: "taxonomy-node";
      id: string;
    }
  | {
      kind: "tile-set";
      id: string;
      sourceTaxonomyId: string | null;
    }
  | {
      kind: "tile";
      id: string;
      sourceTileSetId: string;
    };

export function encodeSystemCatalogDragPayload(payload: SystemCatalogDragPayload): string {
  return JSON.stringify(payload);
}

export function decodeSystemCatalogDragPayload(value: string): SystemCatalogDragPayload | null {
  try {
    const parsed = JSON.parse(value) as Partial<SystemCatalogDragPayload> | null;
    if (!parsed || typeof parsed !== "object" || typeof parsed.kind !== "string") {
      return null;
    }
    if (parsed.kind === "taxonomy-node" && typeof parsed.id === "string") {
      return { kind: "taxonomy-node", id: parsed.id };
    }
    if (
      parsed.kind === "tile-set" &&
      typeof parsed.id === "string" &&
      (typeof parsed.sourceTaxonomyId === "string" || parsed.sourceTaxonomyId === null)
    ) {
      return {
        kind: "tile-set",
        id: parsed.id,
        sourceTaxonomyId: parsed.sourceTaxonomyId,
      };
    }
    if (
      parsed.kind === "tile" &&
      typeof parsed.id === "string" &&
      typeof parsed.sourceTileSetId === "string"
    ) {
      return {
        kind: "tile",
        id: parsed.id,
        sourceTileSetId: parsed.sourceTileSetId,
      };
    }
  } catch {
    return null;
  }

  return null;
}

export interface SectionCardProps {
  title: string;
  description?: string;
  children: ReactNode;
}
